const CANONICAL_TAX_AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;

export function normalizeTaxAmount(input: string): string | null {
  const candidate = input.trim().replace(/,/g, '.');

  return CANONICAL_TAX_AMOUNT_PATTERN.test(candidate) ? String(Number(candidate)) : null;
}

export function getCommaTaxAmountCanonicalForm(storedAmount: string): string | null {
  if (!storedAmount.includes(',')) return null;

  const digitsAndSeparator = storedAmount
    .trim()
    .replace(',', '.')
    .replace(/[^\d.]/g, '');

  return normalizeTaxAmount(digitsAndSeparator);
}
